/**
 * Budget Allocation Service
 * Register Angular service for Budget Allocations
 *
 * @package:  frictionlessdigital/dashboard
 * @version:  2.7
 * @author:   Cyrill N KALITA
 * @return    Resource
 */

import angular from 'angular';

angular.module('flsServices').factory('BudgetAllocation', ['$resource', function($resource){
    return $resource('/api/aggregate/v1/budget-allocation');
}]);
